import useClientFeatureFlag from '@app/hooks/use-client-feature-flag';

import QuickFilters from './quick-filters';

type Props = Omit<React.ComponentProps<typeof QuickFilters>, 'isFolderV2'>;

const QuickFiltersContainer = (props: Props) => {
  const isFolderV2 = useClientFeatureFlag('folder-v2');
  return (
    <QuickFilters
      {...props}
      isFolderV2={isFolderV2}
    />
  );
};

export default QuickFiltersContainer;
